enum WidgetType {
  Pdp = 'PDP',
  Plp = 'PLP',
  Faq = 'FAQ',
  Icon = 'ICON',
  Text = 'TEXT',
  Blog = 'BLOG',
  Menu = 'MENU',
  Looks = 'LOOKS',
  Coins = 'COINS',
  Ticker = 'TICKER',
  Button = 'BUTTON',
  Orders = 'ORDERS',
  Ledger = 'LEDGER',
  SignIn = 'SIGN_IN',
  SignUp = 'SIGN_UP',
  Profile = 'PROFILE',
  Rewards = 'REWARDS',
  MenuBar = 'MENU_BAR',
  Wishlist = 'WISHLIST',
  Articles = 'ARTICLES',
  Carousel = 'CAROUSEL',
  CarouselWithText = 'CAROUSEL_TEXT',
  TextList = 'TEXT_LIST',
  BlogTags = 'BLOG_TAGS',
  BlogList = 'BLOG_LIST',
  Countdown = 'COUNTDOWN',
  Instagram = 'INSTAGRAM',
  BlogShare = 'BLOG_SHARE',
  Collection = 'COLLECTION',
  InlineForm = 'InlineForm',
  SearchMenu = 'SEARCH_MENU',
  ScrollList = 'SCROLL_LIST',
  LedgerItem = 'LEDGER_ITEM',
  DrawerMenu = 'DRAWER_MENU',
  Breadcrumbs = 'BREADCRUMBS',
  LinkWrapper = 'LINK_WRAPPER',
  ImageBanner = 'IMAGE_BANNER',
  ProductList = 'PRODUCT_LIST',
  ShoppingBag = 'SHOPPING_BAG',
  VideoBanner = 'VIDEO_BANNER',
  LatestBlogs = 'LATEST_BLOGS',
  OrderReturn = 'ORDER_RETURN',
  Announcement = 'ANNOUNCEMENT',
  OrderDetails = 'ORDERS_DETAILS',
  PasswordReset = 'PASSWORD_RESET',
  OrderExchange = 'ORDER_EXCHANGE',
  PrivacyPolicy = 'PRIVACY_POLICY',
  SimilarStyles = 'SIMILAR_STYLES',
  LedgerItemDot = 'LEDGER_ITEM_DOT',
  BlogVisibility = 'BLOG_VISIBILITY',
  CollectionList = 'COLLECTION_LIST',
  AccountRecover = 'ACCOUNT_RECOVER',
  BlogDisplayTags = 'BLOG_DISPLAY_TAGS',
  RecommendedBlogs = 'RECOMMENDED_BLOGS',
  AccountAddresses = 'ACCOUNT_ADDRESSES',
  DrawerMenuHeader = 'DRAWER_MENU_HEADER',
  OrderReturnTrack = 'ORDER_RETURN_TRACK',
  ScrollListBanner = 'SCROLL_LIST_BANNER',
  MaintenanceBanner = 'MAINTENANCE_BANNER',
  CollectionDetails = 'COLLECTION_DETAILS',
  OrderExchangeTrack = 'ORDER_EXCHANGE_TRACK',
  DrawerMenuNavigation = 'DRAWER_MENU_NAVIGATION',
  BlogSocialMediaShare = 'BLOG_SOCIAL_MEDIA_SHARE',
  OccasionPopup = 'OCCASION_POPUP',
  MyProfileForm = 'MY_PROFILE_FORM_WIDGET',
  CountdownTimer = 'COUNTDOWN_TIMER'
}

export default WidgetType;
